import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  recipes: null,
  editedRecipe: null,
  recipeMode: "",
  savedRecipe: null,
  saveRecipeSuccess: false,
  sharedRecipeInfo: {
    details: [],
    success: [],
    farmerName: "",
  },
  shareRecipeSuccess: false,
  chemicals: [],
  recipeTypes: [],
};

const recipeSlice = createSlice({
  name: "recipe",
  initialState,
  reducers: {
    setRecipes: (state, action) => {
      state.recipes = action.payload;
    },
    setEditedRecipe: (state, action) => {
      state.editedRecipe = action.payload;
    },
    setSavedRecipe: (state, action) => {
      state.savedRecipe = action.payload;
    },
    setSaveRecipeSuccess: (state, action) => {
      state.saveRecipeSuccess = action.payload;
    },
    setSharedRecipeInfo: (state, action) => {
      state.sharedRecipeInfo.success = action.payload.success;
      state.sharedRecipeInfo.details = action.payload.details;
      state.sharedRecipeInfo.farmerName = action.payload.farmerName;
    },
    setShareRecipeSuccess: (state, action) => {
      state.shareRecipeSuccess = action.payload;
    },
    setRecipeMode: (state, action) => {
      state.recipeMode = action.payload;
    },
    setChemicals: (state, action) => {
      state.chemicals = action.payload;
    },
    setRecipeTypes: (state, action) => {
      state.recipeTypes = action.payload;
    },
  },
});

export const {
  setRecipes,
  setEditedRecipe,
  setSavedRecipe,
  setSaveRecipeSuccess,
  setSharedRecipeInfo,
  setShareRecipeSuccess,
  setRecipeMode,
  setChemicals,
  setRecipeTypes,
} = recipeSlice.actions;
export default recipeSlice.reducer;
